/**
 * Workshop (8³) vs Atelier (16³) tier constants — shared client + worker.
 */

export const MYSTERY_TIER = {
    WORKSHOP: 'workshop',
    ATELIER: 'atelier',
};

export const PUBLIC_ATELIER_ID = 'public-syndicate-0000';
export const PUBLIC_WORKSHOP_ID = 'public-workshop-0000';

/** Unlock Atelier after this many Workshop slice solves (lifetime). */
export const ATELIER_UNLOCK_SLICES = 6;
/** Or after this many Workshop mysteries ≥50% with personal contribution. */
export const ATELIER_UNLOCK_HALF_CLEARS = 2;

export const TIER_LABEL = {
    workshop: 'Workshop',
    atelier: 'Atelier',
};

export const TIER_GRID = {
    workshop: 8,
    atelier: 16,
};

export const TIER_MAX_SLICES = {
    workshop: 10,
    atelier: 16,
};

export function normalizeTier(raw) {
    const t = String(raw || '').toLowerCase();
    return t === MYSTERY_TIER.ATELIER ? MYSTERY_TIER.ATELIER : MYSTERY_TIER.WORKSHOP;
}

export function publicSyndicateForTier(tier) {
    return normalizeTier(tier) === MYSTERY_TIER.WORKSHOP
        ? PUBLIC_WORKSHOP_ID
        : PUBLIC_ATELIER_ID;
}

export function roomDoName(syndicateId, date, tier) {
    return `${syndicateId}:${date}:${normalizeTier(tier)}`;
}
